<template>
        <div class="wrapper">
          <details>
         <summary> 2020. 01. 01 ~ 2023 .08. 14 적용 (클릭)</summary> 
       <article class="title">
        <h1 class="hi">개인정보처리방침 </h1>
        <p>'삼성전자 주식회사'(이하 '회사'라 합니다)는 이용자의 개인정보를 중요시하며, 「정보통신망 이용촉진 및 정보보호 등에 관한 법률」, 「개인정보 보호법」을 준수하기 위하여 노력하고 있습니다.</p>
        <p>회사는 이용자로부터 제공받은 개인정보를 어떠한 용도와 방식으로 이용하고 있으며, 개인정보 보호를 이해 어떠한 조치를 취하고 있는지 개인정보처리방침을 통해 알려드립니다.</p>
        </article>

        <ol class ="info-list">
          <li class="info-item-0">
            <h2>0. 총칙</h2>
            <p>"개인정보"란 살아 있는 개인에 관한 정보로서 성명, 주민등록번호 및 영상 등에 의하여 특정 개인을 알아볼 수 있는 정보(해당 정보만으로는 특정 개인을 알아볼 수 없더라도 다른 정보와 쉽게 결합하여 알아볼 수 있는 것을 포함)를 말합니다.</p>
            <p>회사는 이용자가 본 개인정보처리방침을 언제나 쉽게 볼 수 있도록 Samsung-EcoPackage 홈페이지
              <a href="https://www.samsung-ecopackage.com">(https://www.samsung-ecopakcage.com)</a>
              의 첫 화면에 공개하고 있습니다.
            </p>            
            <p>회사는 개인정보처리방침을 지속적으로 개선하기 위하여 개정에 필요한 절차를 정하고 있습니다. 또한 개인정보처리방침을 개정하는 경우 이에 버전번호 등을 부여하여 이용자가 개정된 사항을 쉽게 알아볼 수 있게 합니다.</p>
            <p>본 방침은 2020년 3월 27일부터 시행되며, 이를 개정하는 경우 웹사이트에 공지(또는 서면·이메일·전화·SMS 등의 방법으로 개별 공지)합니다.</p>
            </li>
          <li class="info-item-1">
             <h2>1. 이용자 및 법정대리인의 권리 및 그 행사 방법</h2>
             <ol class="two-depth">
                <li>
                  <p>(1) 이용자 및 법정대리인은 등록되어 있는 이용자 본인 혹은 당해 만 14세 미만자의 개인정보와 관련하여, 다음과 같은 사항에 대하여 열람, 정정·삭제, 처리정지, 혹은 동의 철회를 언제든지 요청할 수 있습니다.</p>
                    <ul class="two-depth">
                      <li> – 회사가 가지고 있는 개인정보: 하기 4.(1)에 기재된 사항</li>
                    </ul>
                  <p>이를 위하여 대표전화(1588-4730)를 이용하거나,  개인정보 보호책임자에게 서면·이메일·전화로 연락할 수 있습니다.</p>
                  <p>회사는 다음에 해당하는 경우 개인정보의 전부 또는 일부에 대하여 열람 혹은 정정·삭제 요청을 거부할 수 있습니다.</p>
                  <ul class="two-depth">
                      <li> – 법률에 따라 열람이 금지되거나 제한되는 경우</li>
                      <li> – 다른 사람의 생명·신체를 해할 우려가 있거나 다른 사람의 재산과 그 밖의 이익을 부당하게 침해할 우려가 있는 경우</li>
                    </ul>
                </li>
                <li>
                  <p>(2) 이용자가 개인정보의 오류에 대해 정정을 요청한 경우, 회사는 정정을 완료하기 전까지 해당 개인정보를 이용하거나 제3자에게 제공하지 않습니다. 또한 오류가 있는 개인정보를 제3자에게 이미 제공한 경우에는 정정된 내용을 제3자에게 지체 없이 통지합니다.</p>
                  <p>회사는 이용자 혹은 법정대리인의 요청에 의해 삭제 또는 처리 정지된 개인정보를 “7. 개인정보의 보유 및 이용기간”에 명시된 바에 따라 처리하고, 그 외의 용도로 열람 또는 이용할 수 없게 합니다.</p>
                  <p>이용자는 자신의 개인정보를 최신의 상태로 정확하게 입력해야 합니다. 이용자가 입력한 부정확한 정보로 인해 발생하는 사고의 책임은 이용자 자신에게 있으며, 타인 정보의 도용 등 허위정보를 입력할 경우 회원자격이 상실될 수 있습니다.</p>
                  <p>이용자에게는 개인정보를 보호받을 권리뿐만 아니라 스스로를 보호하고 타인의 정보를 침해하지 않을 의무도 있습니다. 비밀번호 등 이용자의 개인정보가 유출되지 않도록 조심하고, 게시물 등 타인의 개인정보를 훼손하지 않도록 유의해 주십시오. 이 같은 책임을 다하지 않고 타인의 정보 및 존엄성을 훼손할 시에는 「정보통신망 이용촉진 및 정보보호 등에 관한 법률」 등에 의해 처벌 받을 수 있습니다.</p>
                </li>
             </ol>
          </li>
          <li class="info-item-2">
             <h2>2. 개인정보 보호책임자 및 고객 지원 담당 부서</h2>
              <p>회사는 이용자의 개인정보를 보호하고 개인정보와 관련된 불만을 처리하기 위하여 아래와 같이 담당 부서 및 개인정보 보호책임자를 지정하고 있습니다.</p>
              <ol class="two-depth">
                <li>
                  <p>(1) 고객 지원 담당 부서</p>
                  <p>고객 지원 담당 부서 : 삼성전자 VD사업부 디자인팀</p>
                  <p>전화 : 02) 6147-5724</p>
                  <p>문의처 : ssd.son@samsung.com</p>
                  </li>
                  <li>
                    <p>(2) 개인정보 보호책임자 및 개인정보 보호 담당 부서</p>
                    <p>개인정보 보호책임자 : 개인정보보호사무국장</p>
                    <p>개인정보 보호 담당 부서 : 개인정보보호사무국</p>
                    <p>전화 : 1588-4730</p>
                    <p>문의처 : privacy.sec@samsung.com</p>
                  </li>
                  <li>
                    <p>(3) 기타 기관</p>
                    <p>이용자는 회사의 서비스를 이용하며 발생한 개인정보 보호와 관련된 모든 민원을 개인정보 보호책임자 혹은 담당 부서로 신고할 수 있습니다. 회사는 이용자의 신고사항에 대해 신속하고 충분한 답변을 드릴 것입니다. 기타 개인정보 침해에 대해 신고나 상담이 필요한 경우에는 아래 기관에 문의하시기 바랍니다.</p>
                      <ul>
                          <li>– 개인정보침해 신고센터 (https://privacy.kisa.or.kr / 국번 없이 118)</li>
                          <li>– 대검찰청 과학수사부 사이버수사과 (http://cybercid.spo.go.kr / 국번 없이 1301)</li>
                          <li>– 경찰청 사이버안전국 (http://cyberbureau.police.go.kr / 국번 없이 182)</li>
                      </ul>
                  </li>
              </ol>
          </li>
          <li class="info-item-3">
            <h2>3. 개인정보 자동 수집 장치의 설치, 운영, 거부에 관한 사항</h2>
            <h3>(정보통신망 이용촉진 및 정보보호 등에 관한 법률 적용대상인 경우에 한하여 적용됩니다)</h3>
            <p>회사는 이용자의 정보를 수시로 저장하고 찾아내는 ‘쿠키(cookie)’ 등을 사용합니다. 쿠키란 회사의 웹사이트 운영에 이용되는 서버가 이용자의 브라우저에 보내는 아주 작은 텍스트 파일로, 이용자의 컴퓨터 하드디스크에 저장됩니다.</p>
            <ol>
                <p>(1) 쿠키 설정 방법</p>
                <p>이용자는 쿠키 설치에 대한 선택권을 가지고 있습니다. 따라서 웹브라우저에서 옵션을 설정함으로써 모든 쿠키를 허용하거나, 쿠키가 저장될 때마다 확인하거나, 모든 쿠키의 저장을 거부할 수 있습니다.</p>
                <p>단, 이용자가 쿠키 설치를 거부할 경우 서비스 제공에 어려움이 있을 수 있습니다.</p>
                <li>
                    <ul>
                      <li>
                        <p>– 쿠키 설정 방법 (인터넷 익스플로러 11.0을 사용하고 있는 경우)</p>
                         <p>   : 「도구」메뉴에서 「인터넷옵션」을 선택합니다. 「개인정보 탭」을 클릭합니다.</p>
                         <p>「고급」을 선택하여 자신에게 맞는 쿠키 허용 수준을 설정합니다.</p>
                      </li>
                      <li>
                        
                        <p>– 받은 쿠키를 보는 방법 (익스플로러 11.0을 사용하고 있는 경우)</p>
                        <p>: 「도구」 메뉴에서 「인터넷옵션」을 선택합니다.</p>
                        <p>「일반」 탭을 클릭합니다.</p>
                        <p>'검색기록’ 의 「설정」으로 들어가서 「파일보기」에서 확인합니다.</p>
                      </li>
                       <li> 
                        <p>– 쿠키 설치 거부 방법 (인터넷 익스플로어 11.0 사용하고 있는 경우)</p>
                        <p>: 「도구」 메뉴에서 「인터넷옵션」을 선택합니다.</p>
                        <p>「개인정보 탭」 을 클릭합니다.</p>
                        <p>「기본값」에서 상위레벨을 선택하여 “모든 쿠키차단”으로 설정합니다.</p>  
                      </li>
                    </ul>
                </li>
            </ol>
          </li>
          <li class="info-item-4">
            <h2>4. 개인정보 수집 항목 및 수집 방법</h2>
            <p>(1) 개인정보 수집 항목</p>
            <p>회사는 최초 회원 가입 또는 서비스 이용 시 이용자로부터 아래와 같은 개인정보를 수집하고 있습니다.</p>
              <table class="type-short">
                <tbody>
                  <tr>
                    <th class>구분</th>
                    <th class>자세한 내용</th>
                  </tr>
                  <tr>
                    <td class>① 필수항목</td>
                    <td class>□ IP, timestamp 등 사용자가 본 서비스에 접속 시 자동으로 생성되는 정보</td>
                  </tr>
                </tbody>
              </table>
            <p>※ 회사는 이용자의 사생활을 현저히 침해할 우려가 있는 민감정보(사상·신념, 노동조합·정당의 가입·탈퇴, 정치적 견해, 건강, 성생활 등에 관한 정보 등)는 수집하지 않습니다.</p>
            <p>※ 회사는 원칙적으로 이용자가 만 14세 미만자일 경우 개인정보를 수집하지 않습니다. 서비스 이용을 위하여 만 14세 미만자의 개인정보를 부득이 수집할 때에는 사전에 법정대리인에게 동의를 구하고, 관련 업무가 종료됨과 동시에 해당 정보를 지체 없이 파기하며, 업무가 진행되는 동안 개인정보를 철저히 관리합니다.</p>
            <p>(2) 개인정보 수집 방법</p>
            <p>회사는 다음과 같은 방법으로 개인정보를 수집합니다.</p>
            <ul>
              <li>
                <p>- 생성정보 수집 툴을 통한 수집</p>
              </li>
            </ul>
          </li>
  
          <li class="info-item-5">
            <h2>5. 개인정보의 수집∙이용 목적</h2>
            <p>회사는 수집한 개인정보를 다음의 목적을 위해 사용합니다.</p>
            <table class="type-short">
                <tbody>
                  <tr>
                    <th class>목적</th>
                    <th class> 자세한 내용</th>
                  </tr>
                  <tr>
                    <td class>① 서비스 제공</td>
                    <td class> □ 서비스 제공.</td>
                  </tr>
                </tbody>
              </table>
          </li>
          <li class="info-item-6">
            <h2>6. 제3자에게의 개인정보 제공</h2>
            <p>회사는 원칙적으로 이용자의 개인정보를 외부에 제공하지 않습니다. 다만, 아래의 경우는 예외로 합니다.</p>
            <ul>
              <li>
                  <p>– 법령의 규정에 의거한 경우, 수사 목적으로 법령에 정해진 절차와 방법에 따라 수사기관의 요구가 있는 경우</p>
              </li>
              <li>
                <p>– 유료 서비스 제공에 따른 요금 정산을 위하여 필요한 경우</p>
              </li>
              <li>
                <p>– 통계 작성, 학술연구, 시장조사를 위해 특정 개인을 식별할 수 없는 형태로 가공해서 제공하는 경우</p>
              </li>
              <li>
                <p>– 이용자가 사전에 동의한 경우</p>
              </li>
            </ul>
            <p>위에 기재된 업체는 추후 변동될 수 있습니다. 업체가 변경되거나, 기재된 내용 외에 이용자의 개인정보를 제공 혹은 공유하는 경우에는 별도로 이용자 동의를 구한 후 해당 정보를 제공합니다.</p>
          </li>
          <li class="info-item-7">
            <h2>7. 개인정보의 보유 및 이용 기간</h2>
            <p>회사는 원칙적으로 개인정보의 수집 및 이용목적이 달성된 후에는 해당 정보를 지체 없이 파기합니다.</p>
            <p>단, 관련 법령의 규정에 의하여 보존할 필요가 있는 경우 회사는 아래와 같이 관련 법령에서 정한 일정한 기간 동안 개인정보를 보관합니다. 이 경우 회사는 해당 정보를 별도의 데이터베이스(DB)로 옮기거나 다른 장소에 보관합니다.</p>
             <table class="type-wide">
                <tbody>
                  <tr>
                    <th class>보유 항목</th>
                    <th class>보유 기간</th>
                    <th class> 법적 근거</th>
                  </tr>
                  <tr>
                    <td class>계약 또는 청약철회 등에 관한 기록</td>
                    <td class>5년</td>
                    <td class> 전자상거래 등에서의 소비자보호에 관한 법률</td>
                  </tr>
                  <tr>
                    <td class>대금결제 및 재화 등의 공급에 관한 기록</td>
                    <td class> 5년</td>
                    <td class> 전자상거래 등에서의 소비자보호에 관한 법률</td>
                  </tr>
                  <tr>
                    <td class>소비자의 불만 또는 분쟁처리에 관한 기록</td>
                    <td class> 3년</td>
                    <td class>전자상거래 등에서의 소비자보호에 관한 법률</td>
                  </tr>
                  <tr>
                    <td class>{신용정보의 수집/처리 및 이용 등에 관한 기록</td>
                    <td class> 3년</td>
                    <td class> 신용정보의 이용 및 보호에 관한 법률</td>
                  </tr>
                  <tr>
                    <td class>표시/광고에 관한 기록</td>
                    <td class> 6개월</td>
                    <td class> 전자상거래 등에서의 소비자보호에 관한 법률</td>
                  </tr>
                  <tr>
                    <td class>이용자의 인터넷 등 로그 기록 / 이용자의 접속지 추적자료
                      <br>
                      그 외의 통신사실 확인 자료
                    </td>

                    <td class> 3개월
                      <br>
                      12개월
                    </td>

                    <td class> 통신비밀보호법</td>
                  </tr>
                </tbody>
              </table>
          </li>
          <li class="info-item-8">
            <h2>8. 개인정보의 파기 절차 및 파기 방법</h2>
            <p>개인정보의 파기 절차 및 파기 방법은 다음과 같습니다.</p>
            <p>(1) 파기 절차</p>
            <p>이용자의 개인정보는 목적이 달성된 후 별도의 DB(종이의 경우 별도의 서류함)로 옮겨져 내부 방침 및 기타 관련 법령에 의한 정보보호 사유에 따라(“7. 개인정보의 보유 및 이용기간” 참조) 일정 기간 보관된 후 파기됩니다. 별도의 DB로 옮겨진 개인정보는 법령에 의한 경우 외에는 보유되는 목적 이외의 다른 목적으로 이용되지 않습니다.</p>
            <p>(2) 파기 방법 </p>
            <p>회사는 기록을 재생할 수 없는 기술적 방법을 사용하여 전자적 파일 형태로 저장된 개인정보를 삭제합니다. 종이에 출력된 개인정보는 분쇄나 소각을 통해 파기됩니다.</p>
          </li>
          <li class="info-item-9">
            <h2>9. 개인정보의 위탁 및 국외 이전</h2>
             <p>회사는 서비스 제공을 위해 필요한 경우에 한해 아래와 같이 서비스 별로 개인정보의 처리 업무를 외부 전문 업체에 위탁합니다.</p>
            <p>회사는 개인정보의 처리를 위탁하는 경우 개인정보 보호에 만전을 기하기 위하여 개인정보 보호 관련 지시 엄수 의무, 개인정보에 대한 비밀 유지 의무, 제3자 제공 금지 및 사고 시 책임부담 의무, 위탁기간 이후 및 처리 종료 후 개인정보의 반환 또는 파기 의무 등을 명확히 규정하고, 수탁업체가 개인정보를 안전하게 처리하도록 감독합니다.</p>
            <p>회사는 수탁업체나 위탁 업무의 내용이 변경될 경우, 이를 웹사이트에 공지(또는 서면·이메일·전화·SMS 등의 방법으로 개별 공지)합니다.</p>
             <table class="type-short">
                <tbody>
                  <tr>
                    <th class>수탁업체의 명칭</th>
                    <th class>위탁하는 업무의 내용</th>
                  </tr>
                  <tr>
                    <td class>Amazon Web Service</td>
                    <td class> □ 본건 서비스 관련 클라우드 서버 운영 및 관리</td>
                  </tr>
                </tbody>
              </table>
              <p>또한 일부 개인정보의 경우, 서비스 제공 및 이용자 편의 증진 등을 위하여 국외 업체에 위탁, 보관하고 있습니다.</p>
          </li>
          <li class="info-item-10">
            <h2>10. 기타 개인정보 처리에 관한 방침</h2>
            <p>(1) 개인정보 보호를 위한 기술적∙관리적 조치</p>
            <p>회사는 이용자의 개인정보 처리 시 개인정보가 분실, 도난, 유출, 변조 또는 훼손되지 않도록 안전성 확보를 위하여 다음과 같은 기술적∙관리적 조치를 취합니다.</p>
            <ol>
              <li>
                <ul>
                  <li>
                      <p>– 내부관리계획의 수립 및 시행</p>
                      <p>ㆍ개인정보를 안전하게 처리하기 위하여 내부관리계획을 수립하고 시행합니다.</p>
                      <p>ㆍ사내 개인정보 보호 전담기구 등을 통해 개인정보 보호조치의 이행사항 및 업무 담당자의 준수 여부를 확인하며, 문제 발견 시 즉시 시정하도록 조치합니다.</p>
                  </li>
                  <li>
                    <p>– 접근 통제 장치의 설치 및 운영</p>
                    <p>ㆍ침입 차단 시스템을 이용하여 외부의 무단 접근을 통제하고 있으며, 그 외에도 시스템상의 보안성을 확보하기 위하여 가능한 모든 기술적 장치를 갖추려고 노력합니다.</p>
                  </li>
                  <li>
                    <p>– 접속 기록의 위조∙변조 방지를 위한 조치</p>
                    <p>ㆍ개인정보 처리시스템에 접속한 기록을 보관∙관리하며, 접속 기록이 위조∙변조되지 않도록 보안 기능을 사용합니다.</p>
                  </li>
                  <li>
                    <p>– 개인정보의 암호화</p>
                    <p>ㆍ이용자의 개인정보는 비밀번호에 의해 보호되며, 파일 보관 시 이를 암호화하거나 파일 잠금 기능(Lock)을 사용합니다. 또한 전송되는 데이터는 암호화되며, 중요한 데이터는 별도의 보안 기능으로 보호됩니다.</p>
                  </li>
                  <li>
                    <p>– 해킹 예방 대책</p>
                    <p>ㆍ백신 프로그램을 이용하여 악성 바이러스에 의한 피해를 방지합니다. 백신 프로그램은 주기적으로 업데이트되며, 갑작스런 바이러스가 출현할 경우 해당 백신이 나오는 즉시 이를 제공함으로써 개인정보 침해를 방지합니다.</p>
                    <p>ㆍ네트워크 상에서 개인정보를 안전하게 전송할 수 있는 암호화 전송 방법인 보안장치(Secure Socket Layer, SSL)를 채택하고 있습니다.</p>
                    <p>ㆍ해킹 등 외부침입에 대비하여 각 서버마다 침입 차단 시스템 및 취약점 분석 시스템 등을 도입하고 보안에 만전을 기합니다.</p>
                    <p>ㆍ개인정보와 일반 데이터를 섞어서 보관하지 않고, 별도의 서버에 분리하여 보관합니다.</p>
                  </li>
                  <li>            
                    <p>– 개인정보 취급 직원의 최소화 및 교육</p>
                    <p>ㆍ이용자를 직접 상대하여 마케팅 업무를 수행하는 자, 개인정보 보호책임자 및 담당자 등 개인정보 관리 업무를 수행하는 자, 기타 업무상 개인정보의 취급이 불가피한 자 등으로 이용자의 개인정보에 대한 접근 권한을 제한합니다.</p>
                    <p>ㆍ개인정보를 취급하는 직원을 대상으로 새로운 보안 기술 및 개인정보 보호 의무 등에 관한 정기적인 사내교육 및 외부 위탁교육을 실시합니다.</p>
                    <p>ㆍ입사 시 전 직원이 보안서약서를 작성하게 함으로써 사람에 의한 정보 유출을 방지합니다. 또한 개인정보 보호조치의 이행사항 및 직원의 준수 여부를 감사하기 위한 내부 절차를 갖추고 있습니다.</p>
                    <p>ㆍ개인정보취급자의 업무 인수인계는 보안이 철저하게 유지된 상태에서 이뤄지며, 입사 및 퇴사 후 개인정보 사고에 대한 책임을 명확화합니다.</p>
                    <p>ㆍ전산실 및 자료 보관실 등을 특별 보호구역으로 지정하여 출입을 통제합니다.</p> 
                  </li>
                  <li>
                         
                    <p>(2) 링크 제공 방침</p> 
                    <p>회사는 다른 회사의 웹사이트 또는 자료에 대한 링크를 이용자에게 제공할 수 있으며, 이용자는 제3자가 개발한 제품 및 서비스를 삼성 서비스를 통해 사용할 수 있습니다 (예를 들어, 제3자가 개발한 어플리케이션을 삼성 갤럭시 스토어에서 다운로드하여 사용하는 경우 등). 이 경우, 회사는 제3자의 사이트, 자료, 제품 및 서비스에 대해 아무런 통제권이 없으므로, 제3자로부터 제공받는 제품 및 서비스나 자료의 유용성에 대해 책임지거나 보증할 수 없습니다. 회사가 제공한 링크를 클릭(click)하여 타 사이트(site)의 페이지로 옮겨갈 경우, 해당 사이트의 개인정보 보호정책은 회사와 무관하므로 새로 방문한 사이트의 정책을 검토해 보시기 바랍니다.</p>   
                  </li>
                </ul>
              </li>
              <li>
                 <p>(3) 이메일 무단수집 거부 방침</p>  
                 <p>회사는 게시된 이메일 주소가 이메일 수집 프로그램 또는 그 밖의 기술적 장치를 통하여 무단 수집되는 것을 거부합니다. 이를 위반 시 「정보통신망 이용촉진 및 정보보호 등에 관한 법률」 등에 의해 처벌 받을 수 있습니다.</p>  
              </li>
               <li>
                <p>(4) 광고성 정보의 전송</p> 
                <p>회사는 이용자의 사전 동의 없이 영리목적의 광고성 정보를 전송하지 않습니다.</p>   
                <p>개인정보처리방침 버전 번호 :   1.0 </p>  
                <p>개인정보처리방침 시행 일자 :     2020.03.27</p>       
              </li>
            </ol>
          </li>
        </ol>
            </details>
        </div>
</template>

<script>


export default {
  components: {
  },
  data() {
    return {
     };
  },
  created() {


  },
  methods: {

  }
};
</script>

<style scoped>
details {
  display: block;
  background-color: black;
  /* margin:auto; */
  margin:auto;
  line-height:1.875;
  letter-spacing:-0.035em;
  max-width: 1200px;

  text-align:left;
}
.wrapper {
  background-color: black;
  /* margin:auto; */
  margin:auto;
  line-height:1.875;
  letter-spacing:-0.035em;
  max-width: 1200px;
}
/* .p{
  margin-block-start:1em;
  margin-block-end:1em;
} */
.hi{
  margin-top: 0px;
  /* background-color: #FFFFFF; */
  text-align: left;
  /* min-height: 80vh; */
  /* position:relative; */
}
/* li{
  margin-top:4.453125vw;
} */
table{
  border-collapse:collapse;
  width:100%;
  text-align:center;
  margin-top:20px;
  margin-bottom:20px;
}
td,th{
  padding:0;
}
td,th{
  border: 1px solid #FFFFFF;
}
.info-item-0, .info-item-1,.info-item-2,.info-item-3,.info-item-4,.info-item-5,.info-item-6,.info-item-7,.info-item-8,.info-item-9,.info-item-10{
  margin-top:30px;
}
.info-item-2{
  margin-top:20px;
}
table.type-short{
  width:365px;
}
table.type-wide{
  width:920px;
}
ul,ol{
  list-style:none;
}
dl,ul,ol,dt,dd,blockquote,p,h1,h2,h3,h4,h5,h6{
  padding:0;
  margin:0;
  text-align:left;
}
tbody{
  display:table-row-group;
  vertical-align:middle;
}
@media (max-width: 1024px) {
  .wrapper{
    max-width: 83.33vw;
    margin:auto;
  }
  details {
  display: block;
  background-color: black;
  /* margin:auto; */
  margin:auto;
  line-height:1.875;
  letter-spacing:-0.035em;
  max-width: 1200px;
  text-align:left;
}
 .hi{
  margin-top: 0px;
  /* background-color: #FFFFFF; */
  text-align: left;
  /* min-height: 80vh; */
  /* position:relative; */
}
table.type-wide{
  max-width: 83.33vw;
}
table.type-short{
  max-width: 83.33vw;
}
table{
  margin-top:10px;
  margin-bottom:10px;
}
}
</style>


    
    
   
   
   
    
   